export { useTabListContext_unstable as useTabListContext } from '@fluentui/react-tabs';
